<template>
  <div class="calcpb">
    <ShowInputItems :calc-type="`paperBug`" />
  </div>
</template>

<script>
// @ is an alias to /src
import ShowInputItems from "@/components/ShowInputItems.vue";

export default {
  name: "CalcPaperBug",
  components: {
    ShowInputItems
  }
};
</script>
